<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row dflex">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="search1" (click)='filter()'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <button (click)="load_data1(0)" [ngClass]="{active_button:type == 0}">
                    <span>همه</span>
                </button>
                <button (click)="load_data1(1)" [ngClass]="{active_button:type == 1}">
                    <span>چکهای دریافتی </span>
                </button>
                <button (click)="load_data1(3)" [ngClass]="{active_button:type == 3}">
                    <span>چکهای دریافتی خرج شده</span>
                </button>
                <button (click)="load_data1(2)" [ngClass]="{active_button:type == 2}">
                    <span>چکهای پرداختی </span>
                </button>
                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" class='matTable table-scroll mat_table_fa_without_scroll_bg pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px' (click)="reset_sort('finance_cheque_id','desc')">
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
                page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:45px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef [hidden]="type != 0" style="max-width:80px"
                [ngClass]="{active1:order == 'site_cheque_type_title ' + asc_desc }"
                (click)="sort('site_cheque_type_title',asc_desc)">
                <span>نوع چک</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)"
                [hidden]="type != 0" style="max-width:80px">{{
                x.site_cheque_type_title }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:80px" [hidden]="type != 0"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="service">
            <mat-header-cell *matHeaderCellDef style="max-width:80px"
                [ngClass]="{active1:order == 'ref_text ' + asc_desc }" (click)="sort('ref_text',asc_desc)">
                <span>سرویس</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)"
                style="max-width:80px">{{
                x.ref_text }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:80px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef style="min-width: 180px;"
                [ngClass]="{active1:order == 'finance_cheque_cheque_title ' + asc_desc }"
                (click)="sort('finance_cheque_cheque_title',asc_desc)">
                <span>بابت</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)"
                class="right rtl" style="min-width: 180px;">
                <div class="right">
                    {{x.finance_cheque_cheque_title | substr:0:25 }}
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width: 180px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="user">
            <mat-header-cell *matHeaderCellDef style="min-width: 180px;"
                [ngClass]="{active1:order == 'user_title ' + asc_desc }" (click)="sort('user_title',asc_desc)">
                <span>عنوان</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)"
                style="min-width: 180px;">
                <div class="right">{{ x.title |
                    substr:0:25 }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width: 180px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="bank">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'bank_title ' + asc_desc }"
                (click)="sort('bank_title',asc_desc)">
                <span>بانک</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)">
                {{ x.bank_title }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="account">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'account_number ' + asc_desc }"
                (click)="sort('account_number',asc_desc)">
                <span>شماره حساب</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)">
                {{x.account_number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="number">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'finance_cheque_cheque_number ' + asc_desc }"
                (click)="sort('finance_cheque_cheque_number',asc_desc)">
                <span>شماره چک</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)">{{
                x.finance_cheque_cheque_number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="due">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'due_date ' + asc_desc }"
                (click)="sort('due_date',asc_desc)">
                <span>تاریخ سررسید</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)">{{
                x.due_date }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'finance_cheque_amount ' + asc_desc }"
                (click)="sort('finance_cheque_amount',asc_desc)">
                <span>مبلغ چک</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.finance_cheque_ref_id)">
                {{ x.finance_cheque_amount | number}}</mat-cell>
            <mat-footer-cell *matFooterCellDef>
                <span *ngIf="type > 0 || search">{{ sum | number }}</span>

            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef style="max-width:100px"
                [ngClass]="{active1:order == 'site_cheque_status_title ' + asc_desc }"
                (click)="sort('site_cheque_status_title',asc_desc)">
                <span>وضعیت چک</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:100px"
                (click)="open_detaile(i,2,x.finance_cheque_ref_id)">{{
                x.site_cheque_status_title }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:100px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="service2">
            <mat-header-cell *matHeaderCellDef style="max-width:100px"
                [ngClass]="{active1:order == 'spend_ref_title ' + asc_desc }" (click)="sort('spend_ref_title',asc_desc)"
                [hidden]="type != 3">
                <span>کجا خرج شده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:100px" [hidden]="type != 3"
                (click)="get_id(x.finance_cheque_ref_id)">
                {{ x.spend_ref_title }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:100px" [hidden]="type != 3"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="info1">
            <mat-header-cell *matHeaderCellDef style="max-width:110px" [hidden]="type != 1">
                <span>اطلاعات دریافت شده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:110px" [hidden]="type != 1"
                [matMenuTriggerFor]="menu1" (click)="get_id(i,x.finance_cheque_ref_id)">
                <span><i class="fas fa-info-circle icon"></i></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:110px" [hidden]="type != 1"></mat-footer-cell>
        </ng-container>
        <mat-menu #menu1="matMenu" class="check-mat-menu-panel" xPosition="before">
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td (click)="check_recieve_cheque(1)" class="cursor right">
                        <span> مشاهده </span>
                    </td>
                </tr>
                <tr>
                    <td class="cursor right" (click)="check_recieve_cheque(2)">
                        <span> مشاهده و ویرایش </span>
                    </td>
                </tr>
            </table>
        </mat-menu>

        <ng-container matColumnDef="info2">
            <mat-header-cell *matHeaderCellDef style="max-width:110px" [hidden]="type != 3">
                <span>اطلاعات خرج شده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:110px" [hidden]="type != 3"
                [matMenuTriggerFor]="menu2" (click)="get_id(i,x.finance_cheque_ref_id)">
                <span><i class="fas fa-info-circle icon"></i></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:110px" [hidden]="type != 3"></mat-footer-cell>
        </ng-container>
        <mat-menu #menu2="matMenu" class="check-mat-menu-panel" xPosition="before">
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td (click)="check_spend_cheque(1)" class="cursor right">
                        <span> کجا خرج کردم - فقط مشاهده </span>
                    </td>
                </tr>
                <tr>
                    <td class="cursor right">
                        <a (click)="check_spend_cheque(2)">
                            <span>کجا خرج کردم - مشاهده و ویرایش</span>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td (click)="check_recieve_cheque(1)" class="cursor right">
                        <span> منشاء چک - فقط مشاهده </span>
                    </td>
                </tr>
                <tr>
                    <td (click)="check_recieve_cheque(2)" class="cursor right">
                        <span> منشاء چک - مشاهده و ویرایش </span>
                    </td>
                </tr>
            </table>
        </mat-menu>



        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngStyle]="{backgroundColor:row.site_cheque_status_color}"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true"></mat-footer-row>

    </mat-table>
    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets//images/preview.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>